import { FlatLookupView } from "@/Common/Api/MedfarDictionaries/Dto/Responses/FlatLookupView";
import { MathHelper } from "@/Common/Helpers/MathHelper";
import { Weight } from "@/Common/Resources/Lookups/Enums/CommonLookupCodes";
import { WeightUnit } from "./Units";

export class WeightUnitConverter {
    private static readonly gramsPerPound = 453.59237; // 1lb = 453.59237g
    private static readonly gramsPerKilogram = 1000; // 1kg = 1000g
    private static readonly kilogramsPerPound = 0.45359237; // 1lb = 0.45359237kg

    public static convert(from: WeightUnit, to: WeightUnit, weight: number, numberOfDecimals?: number): number {
        if (!weight || IsNullOrUndefined(from) || IsNullOrUndefined(to))
            return null;

        let value: number;

        switch (from) {
            case WeightUnit.Kilogram:
                value = this.convertKilogramTo(to, weight);
                break;
            case WeightUnit.Gram:
                value = this.convertGramsTo(to, weight);
                break;
            case WeightUnit.Pound:
                value = this.convertPoundsTo(to, weight);
                break;
        }

        return numberOfDecimals ? MathHelper.roundToDecimals(value, numberOfDecimals) : value;
    }

    public static toLookup(unit: WeightUnit): FlatLookupView | null {
        switch (unit) {
            case WeightUnit.Kilogram:
                return cacheStore.FindLookupByLookupCode(Weight.Kilogram, Weight.Code);
            case WeightUnit.Pound:
                return cacheStore.FindLookupByLookupCode(Weight.Pound, Weight.Code);
            default:
                return null;
        }
    }

    public static convertKilogramTo(to: WeightUnit, weight: number): number {
        switch (to) {
            case WeightUnit.Pound:
                return this.kilogramToPound(weight);
            case WeightUnit.Gram:
                return this.kilogramToGram(weight);
            default:
                return weight;
        }
    }

    public static convertPoundsTo(to: WeightUnit, weight: number): number {
        switch (to) {
            case WeightUnit.Kilogram:
                return this.poundToKilogram(weight);
            case WeightUnit.Gram:
                return this.poundToGram(weight);
            default:
                return weight;
        }
    }

    public static convertGramsTo(to: WeightUnit, weight: number): number {
        switch (to) {
            case WeightUnit.Pound:
                return this.gramToPound(weight);
            case WeightUnit.Kilogram:
                return this.gramToKilogram(weight);
            default:
                return weight;
        }
    }

    public static poundToKilogram(valueInPound: number): number {
        return valueInPound * this.kilogramsPerPound;
    }

    public static kilogramToPound(valueInKg: number): number {
        return valueInKg / this.kilogramsPerPound;
    }

    public static gramToPound(valueInGrams: number): number {
        return valueInGrams / this.gramsPerPound;
    }

    public static poundToGram(valueInPounds: number): number {
        return valueInPounds * this.gramsPerPound;
    }

    public static gramToKilogram(valueInGrams: number): number {
        return valueInGrams / this.gramsPerKilogram;
    }

    public static kilogramToGram(valueInKg: number): number {
        return valueInKg * this.gramsPerKilogram;
    }
}
